import SEO from "@/common/components/seo";
import React from "react";
import Faqs from "../../giveaways/containers/faqs";

function Header() {
	return (
		<div
			className="flex h-screen flex-col items-center justify-center"
			style={{
				backgroundImage: "url(/images/header-background.png)",
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			<p className="web-heading-h1 z-3 text-center text-white max-sm:p-4">
				FAQs
			</p>
			<p className="web-body-b1 mt-4 max-w-[60ch] px-6 text-center text-white-80">
				Everything you need to know about memberships, entries, discounts, and giveaways.
			</p>
		</div>
	);
}

const FaqsPage: React.FC = () => {
	return (
		<div>
			<SEO
				title="FAQs - Reel Rewards"
				description="Find answers to common questions about Reel Rewards, including memberships, entries, discounts, and giveaways."
			/>
			<Header />
			<Faqs className="bg-white" />
		</div>
	);
};

export default FaqsPage;
